import axios from '../axios';
import util from './util';
const apiPath = 'api/admin/memberships';

const membershipApi = {
    index: (query = {}) => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/${id}`
        );
    },
    create: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/create`,
            {
                ...entity
            }
        );
    },
    update: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/update/${id}`,
            {
                ...entity
            }
        );
    },
    delete: id => {
        return axios.delete(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/delete/${id}`
        );
    }
};

export default membershipApi;
